import { createAction, props } from '@ngrx/store';
import { IRouteTrackModel } from '../../../../../src/app/core/models/route-track.model';
import { ILegalEntitiesBusinessesResponse } from '../../todos/models/businesses.model';

export const loadSelectedLegalEntity = createAction(
  '[SelectedLegalEntity] Load Selected LegalEntity',
  props<{ selectedLE: ILegalEntitiesBusinessesResponse }>()
);

export const loadIsSideNavActive = createAction('[IsSideNavActive] Load SideNavActive', props<{ isSideNavActive: boolean }>());

export const loadIsSideNavHidden = createAction('[IsSideNavHidden] Load SideNavHidden', props<{ isSideNavHidden: boolean }>());

export const loadTrackRoutes = createAction('[TrackingRoutes] Load TrackRoutes', props<{ routes: IRouteTrackModel[] }>());
export const clearTrackRoutes = createAction('[ClearTrackingRoutes] Clear TrackRoutes');
